const PANEL_KEY = 'maestro.panel';

export type MaestroPanelSession = 'open' | 'closed';

function canUseSessionStorage(): boolean {
  try {
    return typeof sessionStorage !== 'undefined';
  } catch {
    return false;
  }
}

export function markMaestroLoginWelcome(): void {
  if (!canUseSessionStorage()) return;
  sessionStorage.setItem(PANEL_KEY, 'open');
}

export function markMaestroPanelOpen(): void {
  if (!canUseSessionStorage()) return;
  sessionStorage.setItem(PANEL_KEY, 'open');
}

export function markMaestroPanelClosed(): void {
  if (!canUseSessionStorage()) return;
  sessionStorage.setItem(PANEL_KEY, 'closed');
}

export function clearMaestroPanelSession(): void {
  if (!canUseSessionStorage()) return;
  sessionStorage.removeItem(PANEL_KEY);
}

/** Open on a new session or after login; stay closed if the user dismissed it. */
export function shouldMaestroPanelStartOpen(): boolean {
  if (!canUseSessionStorage()) return true;
  return sessionStorage.getItem(PANEL_KEY) !== 'closed';
}
